import { useEffect, useRef } from 'react';

import {
  markProviderInVideoCall,
  unmarkProviderInVideoCall,
} from 'src/components/pages/pageElements/videoConference/providerInVideoCall';

const HEARTBEAT_MS = 30_000;

/**
 * Marks this tab as an open video call for as long as the component is mounted, so the
 * MyDayToday tab can suppress the "new patient available" notification. Clears on unmount
 * and on beforeunload; a periodic heartbeat keeps the entry fresh against the staleness
 * reconciliation in providerInVideoCall.
 */
export function useMarkProviderInVideoCall(): void {
  const tabId = useRef<string>(`${Date.now()}-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const id = tabId.current;
    markProviderInVideoCall(id);

    const heartbeat = setInterval(() => markProviderInVideoCall(id), HEARTBEAT_MS);
    const onBeforeUnload = () => unmarkProviderInVideoCall(id);
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      clearInterval(heartbeat);
      window.removeEventListener('beforeunload', onBeforeUnload);
      unmarkProviderInVideoCall(id);
    };
  }, []);
}
